import React, { useState } from 'react';
import { Button } from '@neshane/blueberry';
import Modal from '../../../common/components/Modal/Modal';
import './MfaSetupWizard.css';

const RecoveryCodesModal = ({ isOpen, onClose, codes, remaining }) => {
    const [copied, setCopied] = useState(false);

    const handleCopyAll = async () => {
        try {
            await navigator.clipboard.writeText(codes.join('\n'));
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {
            // ignore clipboard errors
        }
    };

    const handleDownload = () => {
        const text = `کدهای بازیابی حساب:\n\n${codes.join('\n')}\n\nاین کدها را در جای امن نگه دارید.`;
        const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'recovery-codes.txt';
        a.click();
        URL.revokeObjectURL(url);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="کدهای بازیابی"
            size="large"
        >
            <div className="recovery-codes">
                <p className="recovery-codes__warning">
                    ⚠️ این کدها فقط یک بار نمایش داده می‌شوند. آن‌ها را همین حالا در جای امن ذخیره کنید.
                    هر کد فقط یک بار قابل استفاده است.
                </p>

                <div className="recovery-codes__grid">
                    {codes.map((code, index) => (
                        <div key={`${code}-${index}`} className="recovery-codes__item">
                            <code>{code}</code>
                        </div>
                    ))}
                </div>

                {typeof remaining === 'number' && (
                    <p className="recovery-codes__remaining">
                        {remaining} کد دیگر از مجموعه قبلی باقی مانده است.
                    </p>
                )}

                <div className="recovery-codes__actions">
                    <Button variant="outline" onClick={handleCopyAll} text={copied ? 'کپی شد ✓' : 'کپی همه'} />
                    <Button variant="outline" onClick={handleDownload} text="دانلود فایل" />
                </div>
            </div>
        </Modal>
    );
};

export default RecoveryCodesModal;